import axios from 'axios'
import { getHeader } from '../../utils/api'
import Cookies from '../../utils/cookies'
import { isChartHost } from '../../routes/chart-hosts'

const DEFAULT_TIMEOUT = 60000
const REFRESH_TOKEN_PATH = '/refresh-token'
let isHandlingChartUnauthorized = false

const AUTH_401_EXCLUDE_URLS = [
  'auth',
  'member/ex/v2/members/me',
  'member/ex/v1/member_products/membership',
  'member/ex/v1/members/change-password',
]

const BASE_SERVICE_401_EXCLUDE_URLS = [
  'auth',
  'google/login',
  'google/register',
]

const shouldRedirectOn401 = (error, exclude401Urls = []) => {
  const response = error.response
  const requestUrl =
    response && response.config ? response.config.url || '' : ''

  return (
    response &&
    response.status === 401 &&
    !exclude401Urls.some((url) => requestUrl.includes(url))
  )
}

const resetChartHostSession = () => {
  if (isHandlingChartUnauthorized) return

  isHandlingChartUnauthorized = true

  localStorage.clear()
  Cookies.DeleteCookieLogedIn()
  Cookies.DeleteCookieType()
  Cookies.DeleteCookieGuide()
  window.location.reload()
}

const attachRequestHeaders = (client) => {
  client.interceptors.request.use(
    (config) => {
      config.headers = getHeader(config)
      return config
    },
    (error) => Promise.reject(error)
  )
}

const attach401Redirect = (client, exclude401Urls = []) => {
  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (shouldRedirectOn401(error, exclude401Urls)) {
        if (isChartHost()) {
          resetChartHostSession()
          return Promise.reject(error)
        }

        window.location.replace(REFRESH_TOKEN_PATH)
      }

      return Promise.reject(error)
    }
  )
}

const createApiClient = ({
  baseURL,
  withRequestHeaders = true,
  with401Redirect = true,
  exclude401Urls = [],
}) => {
  const client = axios.create({
    baseURL,
    timeout: DEFAULT_TIMEOUT,
  })

  if (withRequestHeaders) {
    attachRequestHeaders(client)
  }

  if (with401Redirect) {
    attach401Redirect(client, exclude401Urls)
  }

  return client
}

/** 👇 Auth Url */
const requestAuthUrl = process.env.VUE_APP_BASE_SERVICE_URL_REFACTOR ?? ''
export const requestAuth = createApiClient({
  baseURL: requestAuthUrl,
  exclude401Urls: AUTH_401_EXCLUDE_URLS,
})

/** 👇 Base Service Url */
const requestBaseServiceUrl =
  process.env.VUE_APP_BASE_SERVICE_URL_REFACTOR ?? ''
export const requestBaseService = createApiClient({
  baseURL: requestBaseServiceUrl,
  exclude401Urls: BASE_SERVICE_401_EXCLUDE_URLS,
})

/** 👇 Main Url */
const requestMainUrl = process.env.VUE_APP_CONTENT_API_URL ?? ''
export const requestMain = createApiClient({
  baseURL: requestMainUrl,
})

/** 👇 Gateway Url */
const requestGatewayUrl = process.env.VUE_APP_GATEWAY_API_URL ?? ''
export const requestGateway = createApiClient({
  baseURL: requestGatewayUrl,
})

/** 👇 Media Url */
const requestMediaUrl = process.env.VUE_APP_MEDIA_API_URL ?? ''
export const requestMedia = createApiClient({
  baseURL: requestMediaUrl,
})

/** 👇 Artara Url */
const requestArtaraUrl = process.env.VUE_APP_API_ARTARA ?? ''
export const requestArtara = createApiClient({
  baseURL: requestArtaraUrl,
})

/** 👇 Freemium Url */
const requestFreemiumUrl = process.env.VUE_APP_FREEMIUM_API_URL ?? ''
export const requestFreemium = createApiClient({
  baseURL: requestFreemiumUrl,
})

/** 👇 Statis Data Url */
const requestStatisDataUrl = process.env.VUE_APP_LANDING_PAGE_URL ?? ''
export const requestStatisData = createApiClient({
  baseURL: requestStatisDataUrl,
  withRequestHeaders: false,
  with401Redirect: false,
})
